import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import RightSidebarViewer from '../RightSidebarTabList';
import { auto } from '@popperjs/core';
import { useDispatch } from 'react-redux';
import { setSummaryOpen } from 'features/common/redux/navbarLayout';
import { setAiToolsFilters } from '../redux/setAiToolsFilters';
import { useSetAISearchState } from '../redux/setAISearchState';

type SideSummaryDisplayProps = {
  open: boolean;
  highlights: Array<any>;
  selectedHighlight: any;
  scrollToHighlight: (highlight: any) => void;
  viewerControl: any;
  fileData: any;
  gridView: boolean;
  isAiTab: boolean;
  isAskAIEnabled: boolean;
};

const SideSummaryDisplay = ({
  open,
  selectedHighlight,
  highlights,
  scrollToHighlight,
  fileData,
  viewerControl,
  gridView,
  isAskAIEnabled,
}: SideSummaryDisplayProps) => {
  const dispatch = useDispatch();
  const { clearAISearchState } = useSetAISearchState();
  useEffect(() => {
    return () => {
      const urlParams = new URLSearchParams(window.location.search);
      const askAI = urlParams.get('askAI');
      const isFileAskAI = urlParams.get('fileAskAI');
      if (!askAI && !isFileAskAI && isAskAIEnabled) {
        dispatch(setSummaryOpen(false));
        dispatch(setAiToolsFilters({}));
        clearAISearchState();
      }
    };
  }, [clearAISearchState, dispatch, isAskAIEnabled]);
  if (!open) return null;
  return (
    <>
      <Box
        sx={{
          position: 'relative',
          top: 0,
          right: 0,
          width: auto,
          height: '100%',
          backgroundColor: 'background.paper',
          borderLeft: '1px solid #E5E5E5',
          display: 'flex',
          flexDirection: 'column',
          transition: 'width 1s ease-out',
        }}
      >
        <div
          style={{
            height: 'calc(100vh - 1rem)',
            position: 'relative',
            overflowY: 'auto',
          }}
        >
          <RightSidebarViewer
            selectedHighlight={selectedHighlight}
            highlights={highlights}
            scrollToHighlight={scrollToHighlight}
            fileData={fileData}
            viewerControl={viewerControl}
            gridView={gridView}
          />
        </div>
      </Box>
    </>
  );
};

export default SideSummaryDisplay;
